<script setup lang="ts">
import { Loader2, Rocket } from 'lucide-vue-next';
import { ref } from 'vue';

import PlanFeaturesList from '@/components/settingsMenu/sections/PlanFeaturesList.vue';
import { proPlanFeatures } from '@/components/settingsMenu/sections/plansFeatures';
import PlanTitle from '@/components/settingsMenu/sections/PlanTitle.vue';
import Button from '@/components/ui/button/Button.vue';
import { useStripeStore } from '@/stores/stripeStore';
import { SubscriptionPlan } from '@/types';

const props = defineProps<{
    currentSubscriptionPlan?: SubscriptionPlan;
    isTrial: boolean;
    isGracePeriod: boolean;
}>();

const stripeStore = useStripeStore();

const isButtonLoading = ref(false);

const handleGetPro = async () => {
    if (isButtonLoading.value) return;
    isButtonLoading.value = true;
    try {
        await stripeStore.openUpgradeFlow();
    } finally {
        isButtonLoading.value = false;
    }
};
</script>

<template>
    <section
        class="plan-card flex flex-col gap-7 p-5 rounded-xl border border-border bg-background"
    >
        <PlanTitle
            title="Pro"
            description="Ideal for teams under 100 persons."
            :icon="Rocket"
            :isCurrentPlan="
                !isTrial &&
                !isGracePeriod &&
                props.currentSubscriptionPlan &&
                props.currentSubscriptionPlan === SubscriptionPlan.PRO
            "
        />
        <div class="price flex items-end gap-1">
            <p class="text-3xl font-semibold">27€</p>
            <p class="pb-1 text-sm text-muted-foreground">/month/seat</p>
        </div>

        <PlanFeaturesList :features="proPlanFeatures" size="sm" />

        <Button
            class="w-full mt-auto"
            :disabled="
                isButtonLoading ||
                (!props.isTrial &&
                    !props.isGracePeriod &&
                    props.currentSubscriptionPlan === SubscriptionPlan.PRO)
            "
            @click="handleGetPro"
        >
            <Loader2 v-if="isButtonLoading" class="animate-spin h-4 w-4 mr-2" />
            {{
                props.isTrial
                    ? 'Upgrade to Pro'
                    : props.currentSubscriptionPlan &&
                        props.currentSubscriptionPlan === SubscriptionPlan.PRO
                      ? 'Current plan'
                      : 'Get Pro'
            }}
        </Button>
    </section>
</template>
